import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=62aa213e"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&id=62aa213e&prod&lang=css"
import style1 from "./VerticalNavMenu.vue?vue&type=style&index=1&id=62aa213e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports